<template>
    <div>
        <div class="d-flex flex-column vh-100">
            <div class="row vh-100 overflow-x-hidden">
                <div class="col-6 pl-0 bg-cover-center ml-minus-5px d-none d-lg-block p-0 login-right-img"
                     v-bind:style="{'background-image':'url(' + require('@/assets/img/login-right-bg.jpg')+')'}">
                    <div class="login-text">
                        {{ $t('guest_student_application_system')}}
                    </div>
                </div>
                <div class="col-12 col-lg-6 bg-white rounded-lg mr-0 mr-md-minus-5px z-index-1 shadow">
                    <div class="d-flex align-items-start flex-column h-100">
                        <div class="my-auto w-100">
                            <div class="row justify-content-center p-5">
                                <div class="col-12 mb-4 d-flex justify-content-between align-items-center border-bottom pb-4">
                                    <div class="flex-grow-1"></div>
                                    <div class="d-flex justify-content-center flex-grow-1">
                                         <img src="@/assets/img/bau-logo-for-light.svg" alt="BAU Logo">
                                    </div>
                                    <div class="d-flex align-items-center justify-content-end flex-grow-1">
                                        <b-button class="btn-40 d-lg-flex shadow-sm" variant="outline-secondary"
                                            @click="changeLocale('en')" v-if="locale ==='tr'">
                                            EN
                                        </b-button>
                                        <b-button class="btn-40 d-lg-flex shadow-sm" variant="outline-secondary"
                                            @click="changeLocale('tr')" v-else>
                                            TR
                                        </b-button>
                                    </div>
                                </div>
                                <slot></slot>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { localeChanged } from 'vee-validate';

/**
 * @description Misafir Öğrenci Başvuru Sistemi Layout Bileşeni.
 */
export default {
    name: 'GuestStudentLayout',
    computed: {
        locale() {
            return this.$store.getters['getLocale'] || this.$i18n.locale;
        }
    },
    methods: {
        changeLocale(locale) {
            this.$i18n.locale = locale;
            this.$store.commit('setLocale', locale);
            localeChanged();
        }
    }
}
</script>
